export class SystemAnalysis {
    render() {
        const influenceGraph = `
            <div class="mermaid">
                graph LR
                    %% --- Style Definitions (for nodes) ---
                    classDef actor fill:#d4edda,stroke:#155724,stroke-width:2px;
                    classDef project fill:#cce5ff,stroke:#004085,stroke-width:4px;
                    classDef task fill:#e2e3e5,stroke:#383d41;
                    classDef critical fill:#f8d7da,stroke:#721c24,stroke-width:3px;
                    classDef note fill:#fffbe6,stroke:#d6b656,stroke-width:1px,text-align:left;

                    subgraph "Build & Ship MVP Project: Collaboration Network"
                        direction LR
                        subgraph Actors
                            A[User: Nicolás]:::actor
                            B[User: Bob]:::critical
                            C[Team: Backend]:::actor
                        end
                        
                        subgraph "Implemental Entities"
                            P(Project: Build & Ship MVP):::project
                            T(Task: API Integration):::task
                        end
                    end

                    subgraph "System Insight"
                        %% The note is a separate node, robustly positioned with an invisible link.
                        B_Note("<b>High Centrality Node: 'Bob'</b><br/>His high-weighted 'Unblock'<br/>contributions make him a<br/>critical enabler for project velocity."):::note
                    end

                    %% --- Relationships (using a more stable syntax) ---

                    %% FIX: Use ==> for a thick arrow to represent the high-impact link.
                    %% This avoids the problematic linkStyle command for stroke-width.
                    B ==>|"High-Impact Unblocks<br/>(Edge Weight: 9.5)"| T;

                    %% This is a standard solid link.
                    C -- "Owns & Completes" --> T;

                    %% FIX: Use -..-> for a dashed arrow with a label.
                    %% This is a native and more reliable way to create a dashed effect.
                    T -.->|"Part of"| P;
                    A -.->|"Reviews & Approves"| T;
                    
                    %% Use a standard invisible link for positioning the note. This is very reliable.
                    B --- B_Note;
            </div>
        `;
        const blockerGraph = `
             <div class="mermaid">
             sequenceDiagram
                participant Nicolás
                participant Bob
                participant Charlie

                Nicolás->>Bob: Request Code Review
                activate Bob

                loop In Progress (Delayed)
                    Bob-->>Bob: Reviewing...
                end
                
                note over Bob: Status: In Progress<br/>(Behind Schedule)
                
                rect rgba(255, 0, 0, 0.2)
                    Bob--xCharlie: Review not complete
                    note over Charlie: Status: Blocked<br/>Cannot run tests.
                    Charlie--xNicolás: Tests not run
                    note over Nicolás: Status: Blocked<br/>Cannot deploy.
                end
                
                deactivate Bob
            </div>
        `;
        return `
            <div class="analytics-stratum">
                <div class="governing-principle">
                    <h4>Governing Principle: Causal Chain Mapping & System Dynamics Modeling</h4>
                    <p>Applies graph theory to make the invisible flows of work, influence, and blockage visible, transforming the organization from a static chart into a dynamic, living system.</p>
                </div>

                <div class="chart-container">
                    <h3>Value-Flow & Influence Graph</h3>
                    ${influenceGraph}
                </div>
                
                <hr/>

                <div class="chart-container">
                    <h3>Critical Path & Blocker Chain Analysis</h3>
                    <p>Deployment Pipeline - Root Cause Diagnosis</p>
                    ${blockerGraph}
                    <div class="system-insight">
                        <h4>System Insight</h4>
                        <p><b>Root Cause Diagnosis:</b> The 'Deploy' task is blocked. A time-ordered sequence diagram reveals the root cause is 'Bob', whose 'Code Review' is behind schedule. Management attention should be directed to supporting Bob.</p>
                    </div>
                </div>
            </div>
        `;
    }
    attachEventListeners() {
        if (typeof window.mermaid !== 'undefined') {
            window.mermaid.run({ nodes: document.querySelectorAll('.mermaid') });
        }
    }
}
